import { BaseTesto } from '@lucan/base-ui'

export default function Testo(props) {
  const { children, grassetto, noMargine, ...rest } = props

  return (
    <BaseTesto
      gutterBottom={!noMargine}
      {...(grassetto && { fontWeight: 'bold' })}
      {...rest}
    >
      {children}
    </BaseTesto>
  )
}
